/* eslint-disable no-unused-vars */
import { Pagination, Space, Table, Tooltip } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { AiOutlineEye } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import CustomDatePicker from "../../../../components/datePickers/CustomDatePicker";
import ConfirmTransactions from "../../../../components/modals/ConfirmTransactions";
import { fetchTransactionHistory } from "../../../../utils/services/transfer.service";

function Body({ domainBrand, countries, paycenters }) {
  const history = useHistory();
  const { Column } = Table;
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const menuPortalTarget = document.getElementById("root");

  const [country, setCountry] = useState({});
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [agentBranch, setAgentBranch] = useState({});
  const [approved, setApproved] = useState({});
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [show, setShow] = useState(false);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRow([...selectedRows]);
    },
  };

  const dispatchTransactionHistory = async (payload) => {
    setLoading(true);
    try {
      const response = await fetchTransactionHistory(payload);
      if (response.data.status === "SUCCESS") {
        setHistoryData(response?.data?.data?.transactionHistory);
        setLoading(false);
        toast.success(`transaction history fetched successfully`);
        setCountry({});
        setAgentBranch({});
        setFrom("");
        setTo("");
        setApproved({});
      } else {
        toast.error(`Could not fetch transaction history, try again`);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const fromDate = moment(from).format();
  const toDate = moment(to).endOf("day").format();

  const historyObject = {
    fromDate: fromDate !== "Invalid date" ? fromDate : moment().format(),
    toDate: toDate !== "Invalid date" ? toDate : moment().format(),
  };

  const tableData = historyData?.map((i, index) => {
    return { ...i, key: index };
  });

  return (
    <>
      <ConfirmTransactions
        show={show}
        handleClose={() => {
          setShow(false);
        }}
        data={selectedRow}
        dictionary={dictionary}
      />
      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {dictionary &&
                dictionary["WO_AWAITING_TRANSACTIO_1833674261"] !== undefined
                  ? dictionary["WO_AWAITING_TRANSACTIO_1833674261"]
                  : "Awaiting Transaction"}
              </h1>
            </div>
          </div>

          <div className="row row-sm mb-4">
            <div className="col-lg-12 col-md-12">
              <div className="card overflow-hidden">
                <div className="card-body">
                  <div className="form-row">
                    <div className="col-lg-6 col-md-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_TRANSACTION_ORIGINAT_796479975"]
                          : "Transaction Originating Country"}
                      </label>
                      <Select
                        options={[
                          { label: "All", isoCode3: "ALL" },
                          ...countries,
                        ]}
                        isClearable={false}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                        value={country}
                        name="originatingCountry"
                        onChange={(option) => {
                          setCountry(option);
                        }}
                        className="is-invalid"
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                      <label>From</label>
                      <CustomDatePicker
                        getDate={setFrom}
                        showYearDropdown
                        selectDropdownMode
                        withPortal={true}
                        setMaxDate={new Date()}
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                      <label>To</label>
                      <CustomDatePicker
                        getDate={setTo}
                        showYearDropdown
                        selectDropdownMode
                        withPortal={true}
                        setMaxDate={new Date()}
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_AGENTBRANCH_WHO_CRE_-1702538836"]
                          : "Select Agent/Branch who created transaction"}
                      </label>
                      <Select
                        options={paycenters}
                        getOptionLabel={(option) => option?.name}
                        getOptionValue={(option) => option?.id}
                        isClearable={false}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                        value={agentBranch}
                        name="agent-branch"
                        onChange={(option) => {
                          setAgentBranch(option);
                        }}
                        className="is-invalid"
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_APPROVED_BY_AGEN_-1709264663"]
                          : "Select transactions approved by Agent/Branch"}
                      </label>
                      <Select
                        options={[
                          { label: "ALL", value: "ALL" },
                          { label: "YES", value: true },
                          { label: "NO", value: false },
                        ]}
                        isClearable={false}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                        value={approved}
                        name="approved"
                        onChange={(option) => {
                          setApproved(option);
                        }}
                        className="is-invalid"
                      />
                    </div>

                    {historyData?.length === 0 && (
                      <div className="col-lg-6 col-md-6 mb-3">
                        <button
                          className="btn btn-primary margin-label w-100 d-flex flex-row justify-content-center align-items-center"
                          type="button"
                          onClick={() =>
                            dispatchTransactionHistory(historyObject)
                          }
                        >
                          {dictionary ? dictionary["l_search"] : "Search"}
                          {loading && (
                            <>
                              &nbsp;
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          )}
                        </button>
                      </div>
                    )}
                  </div>
                  {historyData?.length > 0 && (
                    <div className="form-row">
                      <div className="col-lg-6 col-md-6 mb-3">
                        <button
                          className="btn btn-success margin-label w-100 d-flex flex-row justify-content-center align-items-center"
                          type="button"
                          onClick={() => {
                            setShow(true);
                          }}
                        >
                          {dictionary
                            ? dictionary["WO_CONFIRM_TRANSACTIO_-70808584"]
                            : "Confirm Transaction"}
                          {loading && (
                            <>
                              &nbsp;
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          )}
                        </button>
                      </div>
                      <div className="col-lg-6 col-md-6 mb-3">
                        <button
                          className="btn btn-primary margin-label w-100 d-flex flex-row justify-content-center align-items-center"
                          type="button"
                          onClick={() =>
                            dispatchTransactionHistory(historyObject)
                          }
                        >
                          {dictionary ? dictionary["l_search"] : "Search"}
                          {loading && (
                            <>
                              &nbsp;
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div className="table-responsive">
                <Table
                  dataSource={tableData}
                  className="w-100 table tbody"
                  loading={loading}
                  rowSelection={rowSelection}
                >
                  <Column
                    title="Created Date"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />
                  <Column
                    title="Delivery method"
                    dataIndex="deliveryMethod"
                    key="2"
                    className=""
                  />
                  <Column title="PCN" dataIndex="pcn" key="3" className="" />
                  <Column
                    title="Customer"
                    dataIndex="receiver"
                    key="4"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {text}
                        </span>
                      );
                    }}
                  />
                  <Column
                    title="Sending Amount"
                    dataIndex="totalAmountPaid"
                    key="5"
                    className=""
                  />
                  <Column
                    title="Receiving country"
                    dataIndex="countryToName"
                    key="6"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {text}
                        </span>
                      );
                    }}
                  />
                  <Column
                    title="Payment status"
                    dataIndex="status"
                    key="7"
                    className=""
                  />
                  <Column
                    title="Transacton status"
                    dataIndex="display_status"
                    key="8"
                    className=""
                  />
                  <Column
                    title="Action"
                    dataIndex="action"
                    key="9"
                    className=""
                    render={(text, record) => {
                      return (
                        <>
                          <Space size="middle">
                            <Tooltip
                              title={"View Transaction details"}
                              color="#212529"
                              placement="bottom"
                              arrowPointAtCenter={true}
                            >
                              <AiOutlineEye
                                className="cursor-pointer"
                                color={"#6259CA"}
                                fontSize={23}
                                onClick={() =>
                                  history.push({
                                    pathname: "/transfer/details",
                                    state: { data: { ...record } },
                                  })
                                }
                              />
                            </Tooltip>
                          </Space>
                        </>
                      );
                    }}
                  />
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Body;
